export const getTitle = (title) => {
  return window.location.hostname.includes('dashboard') ? 'IBIS-Dashboard' : 'IBIS-Engage';
};
